import {
	Button,
	Dialog,
	DialogContent,
	DialogDescription,
	DialogHeader,
	DialogTitle,
	Input,
} from "@dune/ui";
import { PAGES } from "@dune/types";
import { useNavigate } from "react-router-dom";
import { Mail02, UserPlus01 } from "@untitled-ui/icons-react";
import { Controller, useFormContext } from "react-hook-form";
import { useSendQuizToCreateConstructionByClientDialog } from "./useSendQuizToCreateConstructionByClientDialog";
import { useState } from "react";
import {
	CreateConstructionSiteClientFormData,
	createConstructionSiteSchema,
} from "./useCreateConstructionSiteForm";

type SendQuizToCreateConstructionByClientDialogProps = {
	open: boolean;
	onOpenChange: (open: boolean) => void;
	onSuccess?: () => void;
};

const SendQuizToCreateConstructionByClientDialog = ({
	open,
	onOpenChange,
	onSuccess,
}: SendQuizToCreateConstructionByClientDialogProps) => {
	const navigate = useNavigate();
	const [isSend, setIsSend] = useState(false);
	const clientForm = useFormContext<CreateConstructionSiteClientFormData>();

	const getValidatedFormData = (): CreateConstructionSiteClientFormData => {
		const rawFormData = clientForm.getValues();
		const parseResult = createConstructionSiteSchema.safeParse(rawFormData);
		if (parseResult.success) {
			return parseResult.data;
		}
		return rawFormData;
	};

	const { control, submit, errors, isSubmitting } =
		useSendQuizToCreateConstructionByClientDialog({
			onSuccess: () => {
				setIsSend(true);
				onSuccess?.();
			},
			clientFormData: getValidatedFormData(),
		});
	return (
		<Dialog open={open} onOpenChange={onOpenChange}>
			<DialogContent className="sm:max-w-xl">
				{!isSend ? (
					<>
						<DialogHeader>
							<div className="flex items-center gap-2 pb-2">
								<div className="opacity-60 flex items-center justify-center bg-blue-badge-border rounded-full p-2">
									<UserPlus01 className="w-6 h-6" />
								</div>
							</div>
							<DialogTitle className="text-start">
								Envoyer le formulaire à votre client
							</DialogTitle>
							<DialogDescription className="text-start">
								Invitez votre client à remplir lui-même le formulaire
							</DialogDescription>
						</DialogHeader>
						<form
							className="flex flex-col gap-4 pt-2"
							onSubmit={(e) => {
								e.preventDefault();
								e.stopPropagation();
								submit(e);
							}}
						>
							<Controller
								name="email"
								control={control}
								render={({ field }) => (
									<div className="flex flex-col gap-1">
										<Input
											label="Email client"
											placeholder="you@mail.com"
											value={field.value}
											onChange={(e) => field.onChange(e.target.value)}
											disabled={isSubmitting}
										/>
										{errors.email?.message && (
											<span className="text-red-600 text-sm">
												{errors.email.message}
											</span>
										)}
									</div>
								)}
							/>
							<div className="flex justify-end gap-2">
								<Button
									variant="outline"
									onClick={() => onOpenChange(false)}
									disabled={isSubmitting}
								>
									Annuler
								</Button>
								<Button
									type="submit"
									isLoading={isSubmitting}
									disabled={isSubmitting}
								>
									Envoyer
								</Button>
							</div>
						</form>
					</>
				) : (
					<>
						<DialogHeader className="items-center gap-2">
							<div className="relative mb-2">
								<div className="mx-auto flex items-center justify-center w-16 h-16 rounded-full bg-blue-badge-border opacity-60">
									<Mail02 className="w-7 h-7" />
								</div>
							</div>
							<DialogTitle className="text-2xl font-semibold text-center">
								Questionnaire envoyé
							</DialogTitle>
						</DialogHeader>
						<div className="pt-2">
							<Button
								variant="outline"
								className="w-full rounded-full h-12 text-lg"
								onClick={() => {
									setIsSend(true);
									navigate(PAGES.PROJECTS.index);
								}}
							>
								Fermer
							</Button>
						</div>
					</>
				)}
			</DialogContent>
		</Dialog>
	);
};

export default SendQuizToCreateConstructionByClientDialog;
